import gql from 'graphql-tag';
import { CRM_STEP_FRAGMENT } from '../business/fragment';

export const GET_ALL_STEPS = gql`
  query GetAllSteps($input: QueryAllStepInput!) {
    CRMSteps(input: $input) {
      ...CRMStepDetail
    }
  }
  ${CRM_STEP_FRAGMENT}
`;
